export const getLocalAsset = (path: string) => process.env.NODE_ENV === 'development' ? path : window.location.origin + '/content' + path;